import { FormattedMessage, FormattedNumber, defineMessages } from 'react-intl';
import styled from 'styled-components';

const ColoredDistance = styled.div<{ delta: number }>`
  color: ${props =>
    props.delta > 0 ? 'var(--c-onBase-success)' : 'var(--c-red-300)'};
`;

const messages = defineMessages({
  negativeScoreDelta: {
    defaultMessage: '{scoreDelta} pts away from',
  },
  negativeScoreDeltaSimple: {
    defaultMessage: '{scoreDelta} pts away',
  },
});

type Props = {
  distance: number;
  requiredScore?: number;
  maximumFractionDigits?: number;
  withFromAppendix?: boolean;
};
export const LineupRewardsDistanceLabel = ({
  distance,
  requiredScore,
  withFromAppendix = false,
}: Props) => {
  if (distance === 0 && requiredScore !== 0) {
    return <FormattedMessage defaultMessage="just enough" />;
  }

  const maximumFractionDigits = Math.abs(distance) < 10 ? 2 : 0;
  if (distance > 0) {
    return (
      <ColoredDistance delta={distance}>
        <FormattedMessage
          defaultMessage="{scoreDelta} pts ahead"
          values={{
            scoreDelta: (
              <FormattedNumber
                value={distance}
                maximumFractionDigits={maximumFractionDigits}
                roundingMode="floor"
              />
            ),
          }}
        />
      </ColoredDistance>
    );
  }
  if (distance < 0) {
    return (
      <ColoredDistance delta={distance}>
        <FormattedMessage
          {...(withFromAppendix
            ? messages.negativeScoreDelta
            : messages.negativeScoreDeltaSimple)}
          values={{
            scoreDelta: (
              <FormattedNumber
                value={-distance}
                maximumFractionDigits={maximumFractionDigits}
                roundingMode="floor"
              />
            ),
          }}
        />
      </ColoredDistance>
    );
  }

  return null;
};
